import VrrBreadcrumb from './VrrBreadcrumb';

export default VrrBreadcrumb;
